import React, { useEffect, useState } from 'react'
import './ProductImageSlider.scss'
import { SearchIcon } from '../utils/icons';
import { IoIosArrowDropleft, IoIosArrowDropright } from 'react-icons/io'
import axios from 'axios';
import { Carousel } from 'react-responsive-carousel';

export const ProductImageSlider = ({ product }) => {
    const [images, setImages] = useState([])
    const [slideDesktop, setSlideDesktop] = useState(0)
    const [principalImage, setPrincipalImage] = useState("/static/imgProducts/" + product.Fotografia + "_p.jpg")

    useEffect(() => {
        obtenerImagenes();
    }, [product])

    const obtenerImagenes = async () => {
        let getImage = true
        let number = 1
        let images = ["/static/imgProducts/" + product.Fotografia + "_p.jpg"]
        setPrincipalImage("/static/imgProducts/" + product.Fotografia + "_p.jpg")
        while (getImage === true) {
            const url = "/static/imgProducts/" + product.RefSuelto + "_" + number + ".jpg"
            await axios.get(url).then(res => {
                images.push(url)
                number = number + 1
            }).catch(err => {
                getImage = false
            })
            if (getImage === false) {
                setImages(images)
                break
            }
            if (getImage === true) continue
        }
    }

    const handleClickSlidePrev = () => {
        if (slideDesktop > 0) {
            setSlideDesktop(slideDesktop - 1)
        }
    }

    const handleClickSlideNext = () => {
        if (slideDesktop < images.length && images.length > 4) {
            setSlideDesktop(slideDesktop + 1)
        }
    }

    const handleClickItemImage = (item) => {
        setSlideDesktop(item)
        setPrincipalImage(images[item])
    }

    return (
        <div className="product-image-slider">
            <div className="slider-mobile">
                <Carousel
                    className="carousel-style"
                    interval="10000"
                    showThumbs={false}
                    infiniteLoop={true}>
                    {
                        images.map((image, index) => {
                            return (
                                <div className="image" key={index}>
                                    <img src={image} onError={(e) => {
                                        e.target.onerror = null
                                        e.target.src = '/static/img/no-imagen-fansa.png'
                                    }} alt="" />
                                </div>
                            )
                        })
                    }
                </Carousel>
            </div>
            <div className="slider-desktop">
                <div className="image-big">
                    <img src={principalImage} onError={(e) => {
                        e.target.onerror = null
                        e.target.src = '/static/img/no-imagen-fansa.png'
                    }} alt="" id="11111" />
                </div>
                {images.length > 1 &&
                    <div className="slider-container">
                        <div className="arrow pointer left-arrow" onClick={handleClickSlidePrev}><IoIosArrowDropleft size={30} /></div>
                        <Carousel
                            className="carousel-style"
                            selectedItem={slideDesktop}
                            onClickItem={handleClickItemImage}
                            transitionTime='1000'
                            showArrows={false}
                            showStatus={false}
                            showIndicators={false}
                            showThumbs={false}
                        >
                            {
                                images.map((item, index) => {
                                    return (
                                        <img className={item === principalImage ? "pointer selected" : "pointer"} src={item} onError={(e) => {
                                            e.target.onerror = null
                                            e.target.src = '/static/img/no-imagen-fansa.png'
                                        }} alt="" key={index} />
                                    )
                                })
                            }
                        </Carousel>
                        <div className="arrow pointer right-arrow" onClick={handleClickSlideNext}><IoIosArrowDropright size={30} /></div>
                    </div>
                }
            </div>
        </div>
    )
}